export const NAMESPACE = 'date-pickers';
